<div class="navigation">
  <a [routerLink]="[statusDashboardRoute]" style="text-decoration: none">
    <h3>AV.Park Status</h3>
  </a>
@if(envInfo){
  <div class="d-flex mb-3 center">
    <div class="navbar-brand" ngClass="{{envInfo}}">{{envInfo}}</div>
  </div>
}
  <div class="d-flex mb-3">
    <app-language-selector></app-language-selector>
    @if(authService.isUserLoggedIn()) {
      <button class="user-btn" ejs-dropdownbutton
          [items]="userNavigation"
          [content]="authService.getUserInfo() ? '\<span class=\'user-name\'>' + authService.getUserInfo().firstname + ' ' + authService.getUserInfo().lastname + '\</span>': ''"
          [iconCss]="userIcon"
          (select)="onSelection($event)"></button>
    } @else {
      <a class="login-btn" [routerLink]="[loginRoute]">
        <span class="e-icons icon-user"></span>
        {{ 'i18n.base.login.login' | translate }}
      </a>
    }
  </div>

  <ejs-accordion (created)="onAccordionCreated()" class="mb-3">
    <e-accordionitems>

      <e-accordionitem>
        <ng-template #header>
          <a [routerLinkActive]="['active']" [routerLink]="[statusDashboardRoute]">
            {{ 'i18n.core.navigation.status-dashboard' | translate }}
          </a>
        </ng-template>
      </e-accordionitem>

    @if(authService.isUserLoggedIn() && authService.isUserAdmin()) {
      <e-accordionitem id="{{adminSectionId}}">
        <ng-template #header>
          <div>{{ 'i18n.core.navigation.administration' | translate }}</div>
        </ng-template>
        <ng-template #content>
          <a [routerLinkActive]="['active']" [routerLink]="[servicesAdministrationRoute]">
            {{ 'i18n.core.navigation.services-administration' | translate }}
          </a>
          <a [routerLinkActive]="['active']" [routerLink]="[incidentsAdministrationRoute]">
            {{ 'i18n.core.navigation.incidents-administration' | translate }}
          </a>
          <a [routerLinkActive]="['active']" [routerLink]="[popupsAdministrationRoute]">
            {{ 'i18n.core.navigation.popups-administration' | translate }}
          </a>
          <a [routerLinkActive]="['active']" [routerLink]="[serviceClientsAdministrationRoute]">
            {{ 'i18n.core.navigation.service-clients-administration' | translate }}
          </a>
        </ng-template>
      </e-accordionitem>
    }

    </e-accordionitems>
  </ejs-accordion>
</div>
